module.exports = __webpack_public_path__ + "static/media/crypto.cdb676ce.svg";